{
  "actionbar.actions": "Toiminnot",
  "actionbar.actionsAvailable": "Toiminnot käytettävissä.",
  "actionbar.clearSelection": "Poista valinta",
  "actionbar.selected": "{count, plural, =0 {Ei mitään valittu} other {# valittu}}",
  "actionbar.selectedAll": "Kaikki valittu",
  "actionbutton.pending": "odottaa",
  "breadcrumbs.more": "Lisää kohteita",
  "button.pending": "odottaa",
  "calendar.invalidSelection": "{selectedCount, plural, one {Valittu päivämäärä ei ole} other {Valitut päivämäärät eivät ole}} saatavilla.",
  "combobox.loading": "Ladataan…",
  "combobox.loadingMore": "Ladataan lisää…",
  "combobox.noResults": "Ei tuloksia",
  "contextualhelp.help": "Ohje",
  "contextualhelp.info": "Tiedot",
  "datepicker.endTime": "Päättymisaika",
  "datepicker.startTime": "Alkamisaika",
  "datepicker.time": "Aika",
  "dialog.alert": "Hälytys",
  "dialog.dismiss": "Hylkää",
  "dropzone.replaceMessage": "Pudota korvaava tiedosto",
  "inlinealert.informative": "Tiedot",
  "inlinealert.negative": "Virhe",
  "inlinealert.notice": "Varoitus",
  "inlinealert.positive": "Onnistui",
  "label.(optional)": "(valinnainen)",
  "label.(required)": "(pakollinen)",
  "listview.loading": "Ladataan…",
  "listview.loadingMore": "Ladataan lisää…",
  "menu.loading": "Ladataan…",
  "menu.loadingMore": "Ladataan lisää…",
  "menu.moreActions": "Lisää toimintoja",
  "menu.noResults": "Ei tuloksia",
  "menu.unavailable": "Ei saatavilla, laajenna saadaksesi lisätietoja",
  "notificationbadge.indicatorOnly": "Uusi toiminta",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Ladataan…",
  "picker.loadingMore": "Ladataan lisää…",
  "picker.placeholder": "Valitse…",
  "picker.selectedCount": "{count, plural, =0 {Kohteita ei ole valittu} one {# kohde valittu} other {# kohdetta valittu}}",
  "sidepanel.collapse": "Kutista sivupaneeli",
  "sidepanel.expand": "Laajenna sivupaneelia",
  "slider.maximum": "Maksimi",
  "slider.minimum": "Minimi",
  "table.cancel": "Peruuta",
  "table.drag": "Vedä",
  "table.editCell": "Muokkaa solua",
  "table.loading": "Ladataan…",
  "table.loadingMore": "Ladataan lisää…",
  "table.resizeColumn": "Muuta sarakkeen kokoa",
  "table.save": "Tallenna",
  "table.sortAscending": "Lajittelujärjestys: nouseva",
  "table.sortDescending": "Lajittelujärjestys: laskeva",
  "tag.actions": "Toiminnot",
  "tag.hideButtonLabel": "Näytä vähemmän",
  "tag.noTags": "Ei mitään",
  "tag.showAllButtonLabel": "Näytä kaikki ({tagCount, number})",
  "toast.clearAll": "Tyhjennä kaikki",
  "toast.collapse": "Pienennä",
  "toast.showAll": "Näytä kaikki",
  "treeview.loadingMore": "Ladataan lisää…"
}
